import _color from '@/assets/utils/color.js';
<template>
  <div
    class="mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."
  >
    <vx-card>
      <div class="inline-flex w-4/5 pb-2 mt-3">
        <div class="columns">
          <div
            class="column is-narrow mt-3"
            style="width: 200px; text-align: right"
          >
            <span>Request Number</span>
          </div>
          <div class="column is-narrow -mt-3">
            <div style="width: 200px">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-code"
                icon-no-border
                label-placeholder="Request Number"
                v-model="chRequestsNumber"
                :readonly="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2 mt-3">
        <div class="column is-narrow" style="width: 200px; text-align: right">
          <span>Inbound Number</span>
        </div>
        <div style="width: 450px">
          <vx-input-group>
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="inbordersNumber"
              :readonly="true"
            />
            <p v-if="$v.inbordersNumber.$error & $v.inbordersNumber.$dirty">
              Please Enter Required Data with Correct Format
            </p>

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  color="#5b3cc4"
                  type="filled"
                  icon="search"
                    disabled="disabled"
                  @click="searchInb"
                  >ดึงข้อมูล Inbound</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>Item</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              :readonly="true"
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="ItemNum"
              v-model="itemnum"
            />
          </div>
        </div>
      </div>

      <div class="columns" v-if="acstate == 'EDIT'">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>SKUS_CODE</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              label-placeholder="SKU Number"
              v-model="skus_code"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="columns -mt-4">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>Declaration Number</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-dollar-sign"
              icon-no-border
              label-placeholder="Declaration Number"
              v-model="dclnumber"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>Invoice No.</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="Invoice"
              v-model="invnum"
            />
          </div>
        </div>
      </div>

      <div class="columns -mt-4">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>MAWB</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="เลขที่ใบตราส่งสินค้า 1"
              v-model="mawb"
            />
          </div>
        </div>
        <div
          class="column is-narrow mt-6"
          style="width: 100px; text-align: right"
        >
          <span>HAWB</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="เลขที่ใบตราส่งสินค้า 2"
              v-model="hawb"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>Package</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-package"
              icon-no-border
              v-model="itempck"
              label-placeholder="จำนวนหีบห่อ"
              @blur="$v.itempck.$touch()"
            />
            <p v-if="$v.itempck.$error & $v.itempck.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div
          class="column is-narrow mt-6"
          style="width: 100px; text-align: right"
        >
          <span>หน่วยหีบห่อ</span>
        </div>
        <div class="column is-narrow mt-5">
          <div style="width: 170px">
            <vx-input-group>
              <vs-input
                icon-pack="feather"
                icon-no-border
                v-model="packagesCode"
                @blur="
                  $v.packagesCode.$touch();
                  onModes6();
                "
              />

              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button
                    color="success"
                    type="filled"
                    icon="search"
                    disabled="disabled"
                    @click="searchPacks"
                    >Search</vs-button
                  >
                </div>
              </template>
            </vx-input-group>
            <!-- /Append Button -->
            <p v-if="$v.packagesCode.$error & $v.packagesCode.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>Gross Weight</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-underline"
              icon-no-border
              v-model="itemgw"
              label-placeholder="น้ำหนักรวมหีบห่อ"
              @blur="$v.itemgw.$touch()"
            />
            <p v-if="$v.itemgw.$error & $v.itemgw.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div
          class="column is-narrow mt-6"
          style="width: 100px; text-align: right"
        >
          <span>หน่วยน้ำหนัก</span>
        </div>
        <div class="column is-narrow mt-5">
          <div style="width: 170px">
            <vx-input-group>
              <vs-input
                icon-pack="feather"
                icon-no-border
                v-model="gwunit"
                :readonly="true"
                @blur="
                  $v.gwunit.$touch();
                  onModes3();
                "
              />

              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button
                    disabled="disabled"
                    color="success"
                    type="filled"
                    icon="search"
                    @click="searchGwUnit"
                    >Search</vs-button
                  >
                </div>
              </template>
            </vx-input-group>
            <!-- /Append Button -->
            <p v-if="$v.gwunit.$error & $v.gwunit.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>Description</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 500px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-globe"
              icon-no-border
              label-placeholder="Description"
              @blur="$v.edescription.$touch()"
              v-model="edescription"
            />
            <p v-if="$v.edescription.$error & $v.edescription.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-8"
          style="width: 200px; text-align: right"
        >
          <span>Shipper</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 500px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-globe"
              icon-no-border
              label-placeholder="ShipperName"
              @blur="$v.shname.$touch()"
              v-model="shname"
            />
            <p v-if="$v.shname.$error & $v.shname.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>Consignee</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 500px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-globe"
              icon-no-border
              label-placeholder="ConsigneeName"
              @blur="$v.cnname.$touch()"
              v-model="cnname"
            />
            <p v-if="$v.cnname.$error & $v.cnname.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div
          class="column is-narrow mt-3"
          style="width: 200px; text-align: right"
        >
          <span>ประเภท</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-select autocomplete 
            @change="getcgmove"
            v-model="tmotypes_code" 
            class="w-full">
              <vs-select-item
                v-for="tmotype in tmotypes"
                :key="tmotype.code"
                :value="tmotype.code"
                :text="tmotype.name"
              />
            </vs-select>
            <p v-if="$v.tmotypes_code.$error & $v.tmotypes_code.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div
          class="column is-narrow mt-3"
          style="width: 200px; text-align: right"
        >
          <span>CargoMovement</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-select autocomplete v-model="cgmove" class="w-full">
              <vs-select-item
                v-for="cgmove in cgmoves"
                :key="cgmove.code"
                :value="cgmove.code"
                :text="cgmove.name"
              />
            </vs-select>
            <p v-if="$v.cgmove.$error & $v.cgmove.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div
          class="column is-narrow mt-3"
          style="width: 200px; text-align: right"
        >
          <span>GoodsCargoType</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-select autocomplete v-model="goodcgtype" class="w-full">
              <vs-select-item
                v-for="cgtype in cgtypes"
                :key="cgtype.code"
                :value="cgtype.code"
                :text="cgtype.name"
              />
            </vs-select>
            <p v-if="$v.goodcgtype.$error & $v.goodcgtype.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 200px; text-align: right">
          <span>หมายเลข Container </span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full -mt-2"
              icon-pack="feather"
              icon="icon-list"
              icon-no-border
              label-placeholder="Container No(1)"
              v-model="connumber"
            />
          </div>
        </div>
      </div>

      <div class="columns -mt-4">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>Remark</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Remark"
              v-model="remark"
            />
          </div>
        </div>
        <div
          class="column is-narrow mt-6"
          style="width: 100px; text-align: right"
        >
          <span>Status</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-eye"
              icon-no-border
              label-placeholder="Status"
              v-model="status"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="columns -mt-4">
        <div
          class="column is-narrow mt-6"
          style="width: 200px; text-align: right"
        >
          <span>เหตุผลการดำเนินการ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 400px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-message-square"
              icon-no-border
              label-placeholder="Reason"
              v-model="chreason"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col w-full">
         
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vs-popup fullscreen title="Gross Weight Unit" :active.sync="popupActive3">
      <units v-if="popupActive3" @recsel="recsel3"></units>
    </vs-popup>
    <vs-popup fullscreen title="Net Weight Unit" :active.sync="popupActive4">
      <units v-if="popupActive4" @recsel="recsel4"></units>
    </vs-popup>
    <vs-popup fullscreen title="Qty Unit" :active.sync="popupActive5">
      <units v-if="popupActive5" @recsel="recsel5"></units>
    </vs-popup>
    <vs-popup fullscreen title="Packs Unit" :active.sync="popupActive6">
      <units v-if="popupActive6" @recsel="recsel6"></units>
    </vs-popup>
    <vs-popup fullscreen title="Inbound Number" :active.sync="popupActive7">
      <inborders
        v-if="popupActive7"
        :companyGroupsCode="companyGroupsCode"
        :masrec="0"
        @recsel="recsel"
      ></inborders>
    </vs-popup>
  </div>
</template>

<script>
import { required, decimal, integer } from "vuelidate/lib/validators";
import moment from "moment";
import units from "../packages/grid.vue";
import inborders from "./inbdetailsgrid.vue";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      chreason: "",
      cgmove: "",
      cgmoves: [],
      goodcgtype: "",
      cgtypes: [],
      invnum: "",
      chRequestsNumber: "",
      connumber: "",
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      tmotypes_code: "",
      tmotypes: [],
      itemnw: 0,
      itemqty: 0,
      itempricebaht: 0,
      dutyrateincome: 0,
      dutyincome: 0,
      vatrate: 0,
      vatamount: 0,
      dutyplusvat: 0,
      popupActive3: false,
      popupActive4: false,
      popupActive5: false,
      popupActive6: false,
      popupActive7: false,
      itemgw: "",
      nwunit: "KGM",
      gwunit: "KGM",
      dclnumber: "",
      mawb: "",
      hawb: "",
      skus_code: "",
      inbordersNumber: "",
      itemnum: "",
      edescription: "",
      tdescription: "",
      qtyunit: "C62",
      remark: "",
      status: "",
      itempck: "",
      packagesCode: "",
      proTypesId: "",
      packages: [],
      readonly: false,
      shname: "",
      cnname: "",
      countrys: [],
    };
  },
  validations: {
    inbordersNumber: {
      required,
    },
    edescription: {
      required,
    },
    itemgw: {
      required,
      decimal,
    },
    itempck: {
      required,
      integer,
    },
    packagesCode: {
      required,
    },
    gwunit: {
      required,
    },
    shname: {
      required,
    },
    cnname: {
      required,
    },
    tmotypes_code: {
      required,
    },
    cgmove: {
      required,
    },
    goodcgtype: {
      required,
    },
  },
  components: {
    units,
    inborders,
  },
  props: ["acstate", "recid", "masrec"],
  methods: {
    getcgmove(){
      // alert(this.tmotypes_code)
      if(this.tmotypes_code=='SABIN1'){
        this.cgmove='O'
      }
      else{
        this.cgmove=''
      }
      
    },
    searchInb() {
      // console.log("inb");
      this.popupActive7 = true;
    },
    async recsel(val) {
      this.inbordersNumber = val;
      // console.log(this.inbordersNumber);
      this.popupActive7 = false;

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        skus_code: val,
      };

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/chrequests/getInbDetail`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)

          if (!response.data) {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.inbordersNumber = response.data.inbordersNumber;
            this.dcldate = response.data.dcldate;
            this.invnum = response.data.invnum;
            this.mawb = response.data.mawb;
            this.connumber = response.data.connumber;

            // setTimeout(() => {
            //   this.onModes2();
            //   this.onModes7();
            // }, 500);
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    recsel4(val) {
      // console.log(val);
      this.popupActive4 = false;
      this.nwunit = val;
      setTimeout(() => {
        this.onModes4();
      }, 500);
    },
    searchNwUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive4 = true;
      }, 300);
    },
    async onModes4() {
      // alert("Hi");

      if (this.nwunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.nwunit = "";

        return;
      }
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/inbound-svc/packages/${this.nwunit}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.nwunit = "";
      } else {
        this.nwunit = response4.data.code;
      }
    },
    recsel5(val) {
      // console.log(val);
      this.popupActive5 = false;
      this.qtyunit = val;
      setTimeout(() => {
        this.onModes5();
      }, 500);
    },
    searchQtyUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive5 = true;
      }, 300);
    },
    async onModes5() {
      // alert("Hi");

      if (this.qtyunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.qtyunit = "";

        return;
      }
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/inbound-svc/packages/${this.qtyunit}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.qtyunit = "";
      } else {
        this.qtyunit = response4.data.code;
      }
    },
    recsel3(val) {
      // console.log(val);
      this.popupActive3 = false;
      this.gwunit = val;
      setTimeout(() => {
        this.onModes3();
      }, 500);
    },
    searchGwUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive3 = true;
      }, 300);
    },
    async onModes3() {
      // alert("Hi");

      if (this.gwunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.gwunit = "";

        return;
      }
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/inbound-svc/packages/${this.gwunit}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.gwunit = "";
      } else {
        this.gwunit = response4.data.code;
      }
    },
    recsel6(val) {
      // console.log(val);
      this.popupActive6 = false;
      this.packagesCode = val;
      setTimeout(() => {
        this.onModes6();
      }, 500);
    },
    searchPacks: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive6 = true;
      }, 300);
    },
    async onModes6() {
      // alert("Hi");

      if (this.packagesCode == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.packagesCode = "";

        return;
      }
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/inbound-svc/packages/${this.packagesCode.toUpperCase()}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.packagesCode = "";
      } else {
        this.packagesCode = response4.data.code;
      }
    },
    clsd: function () {
      // this.skus_code = this.gwunit = this.dclnumber = this.itemnum = this.hawb = this.mawb = this.edescription = this.remark = this.itempck = this.packagesCode = this.proTypesId = this.shname = this.cnname =
      //   "";
      let vm = this;
      vm.$emit("grid");
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async onSubmit() {
      this.$v.$touch();
      // alert("Hi");
      let vm = this;

      if (this.$v.$invalid) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
        return;
      } 
      else if (this.itempck == 0) {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Package can't Zero",
          text: "Please Enter The Informaiton",
        });
        return;
      }
      else if (this.cgmove == '') {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Cargo Movement ไม่สามารถว่างได้",
          text: "Please Enter The Informaiton",
        });
        return;
      }
      const moment = require("moment-timezone");
      const timezone = "Asia/Bangkok";

      // Get the current date and time in the specified timezone
      const now = moment().tz(timezone);

      const formData = {
        number: this.recid,
        companyGroupsCode: this.companyGroupsCode,
        businessPartnersCode: this.businessPartnersCode,
        skus_code: this.skus_code,
        inbordersNumber: this.inbordersNumber,
        itemnum: this.itemnum,
        description: this.edescription,
        invnum: this.invnum,
        itemnw: this.itemnw,
        itemqty: this.itemqty,
        qtyunit: this.qtyunit,
        nwunit: this.nwunit,
        remark: this.remark,
        itempck: this.itempck,
        packagesCode: this.packagesCode,
        proTypesId: "1",
        acstate: this.acstate,
        recid: this.recid,
        mawb: this.mawb,
        hawb: this.hawb,
        dclnumber: this.dclnumber,
        gwunit: this.gwunit,
        itemgw: this.itemgw,
        shname: this.shname,
        cnname: this.cnname,
        itempricebaht: this.itempricebaht,
        dutyrateincome: this.dutyrateincome,
        dutyincome: this.dutyincome,
        vatrate: this.vatrate,
        vatamount: this.vatamount,
        tmotypesCode: this.tmotypes_code,
        editor: String(this.userid),
        connumber: this.connumber,
        cgmove: this.cgmove,
        goodcgtype: this.goodcgtype,
        chreason: this.chreason,
        createdAt: now,
      };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // console.log(formData);
      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/chrequests/createAdd`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  async beforeCreate() {
    // console.log("beforecreate");
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    const formData = {
      inbfrom: "SAB_IN",
    };

    const response4 = await axios.post(
      `${BASE_API_URL}/inbound-svc/tmotypes/getTmotypes`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response4.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response4.data.message,
      });
    } else {
      this.tmotypes = response4.data;
    }

    const formData2 = {
      searchval: "",
    };

    const response2 = await axios.post(
      `${BASE_API_URL}/inbound-svc/goodscargotypes/getGoodsCargoTypes`,
      formData2,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response2.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response2.data.message,
      });
    } else {
      this.cgtypes = response2.data;
    }

    const response3 = await axios.post(
      `${BASE_API_URL}/inbound-svc/cargomovements/getCargoMovements`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response3.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response3.data.message,
      });
    } else {
      this.cgmoves = response3.data;
    }
  },
  async created() {
    this.checkProfiles();
    // console.log(this.recid);
    // console.log(this.masrec);
    this.inbordersNumber = this.masrec;

    const formData = {
      number: this.recid,
    };

    if (this.recid != "0") {
      // alert("Edit");
      this.readonly = true;
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        const response = await axios.post(
          `${BASE_API_URL}/inbound-svc/chrequests/getCancel`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );
        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.skus_code = response.data.chrequestdetail.skus_code;
          this.inbordersNumber = response.data.chrequestdetail.refnum;
          this.itemnum = response.data.chrequestdetail.itemnum;
          this.edescription = response.data.chrequestdetail.description;
          this.remark = response.data.chrequest.remark;
          this.status = response.data.chrequest.status;
          this.itempck = response.data.chrequestdetail.itempck;
          this.packagesCode = response.data.chrequestdetail.packagesCode;
          this.proTypesId = response.data.chrequestdetail.proTypesId;
          this.mawb = response.data.chrequestdetail.mawb;
          this.hawb = response.data.chrequestdetail.hawb;
          this.dclnumber = response.data.chrequestdetail.dclnumber;
          this.itemgw = response.data.chrequestdetail.itemgw;
          this.gwunit = response.data.chrequestdetail.gwunit;
          this.shname = response.data.chrequestdetail.shname;
          this.cnname = response.data.chrequestdetail.cnname;
          this.tmotypes_code = response.data.chrequestdetail.tmotypesCode;
          this.connumber = response.data.chrequestdetail.connumber;
          this.chRequestsNumber =
            response.data.chrequestdetail.chRequestsNumber;
          this.cgmove = response.data.chrequestdetail.cgmove;
          this.goodcgtype = response.data.chrequestdetail.goodcgtype;
          this.invnum = response.data.chrequestdetail.invnum;
          this.chreason = response.data.chrequest.chreason;
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      const response = await axios.get(
        `${BASE_API_URL}/inbound-svc/sabs/${this.$route.params.id}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response.data.message,
        });
      } else {
        // this.connumber = response.data[0].cont1;
      }

      this.gwunit = "KGM";
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
